import React from "react";

export const GarantiaCard = ({
  titulo,
  cantidad,
  indicador,
  texto,
  porcentaje,
  className,
  onClick,
  activo = false,
}) => {
  const containerClassName =
    className === undefined
      ? "detalle-clientes-gestionar-container-resumen-item"
      : className;
  return (
    <div className={containerClassName} onClick={onClick}>
      <div
        className={`${"detalle-clientes-gestionar-container-resumen-item-box"} ${
          activo === false
            ? "detalle-clientes-gestionar-container-resumen-item-box-green"
            : "detalle-clientes-gestionar-container-resumen-item-box-yellow"
        } `}
        style={{ width: "180px"}}
      >
        <div className="detalle-clientes-gestionar-container-resumen-title">
          {titulo}
        </div>
        <div className="detalle-clientes-gestionar-container-resumen-valor">
          {cantidad}
        </div>
        <div className="detalle-clientes-gestionar-container-resumen-porcentaje">
          {porcentaje}
        </div>
      </div>
    </div>
  );
};
